
import {finalize} from 'rxjs/operators';
import { map, find } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Operation } from '../operation/operation';
import { Revision } from '../revision/revision';
import { Dossier } from '../dossier/dossier';
import { RecordLink } from '../record-link/record-link';
import { Execution, ExecutionDossier } from './execution';
import { ExecutionService } from './execution.service';
import { NotifierService, DialogService } from '../ui';
import { DossierModel } from '../dossier-model/dossier-model';

@Component({
  templateUrl: './execution-for-operation.component.html',
})
export class ExecutionForOperationComponent implements OnInit {

  execution: Execution
  operation: Operation
  dossierModel: DossierModel

  selectedLinks: RecordLink[]
  selectedDossier: Dossier
  showDossierFilter: boolean = false;

  title: string

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private executionService: ExecutionService,
    private notifier: NotifierService,
    private builder: FormBuilder,
    private dialogService: DialogService
  ) { }

  ngOnInit() {

    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.title = data.title;
      
      this.operation = data.operation;
      this.dossierModel = data.dossierModel;

      this.execution = new Execution();
      this.execution.operation = this.operation;
      this.execution.revision = this.operation.revision;
      this.execution.dossier_model = this.dossierModel;

      this.notifier.endProgress();
    });
  }

  save() {
    this.execution.links = this.selectedLinks;
    
    if (!this.execution || !this.execution.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    this.executionService
      .create(this.execution).pipe(
      finalize(onComplete))
      .subscribe((execution) => {
        this.execution = execution;

        this.notifier.success('Execution créée avec succès');

        // Got to edit screen
        this.router.navigate(['operations', this.operation.id, this.operation.revision.id, 'execute', execution.id]);
      });
  }

  onSelectedRootFields(dossiers: ExecutionDossier[]) {
    this.execution.dossiers = [
      new ExecutionDossier({
        id: this.selectedDossier.id,
        root_field: '',
        dossier: this.selectedDossier,
      }),
      ...dossiers
    ];
  }

  cancel() {
    if (this.selectedDossier) {
      this.selectedDossier = null;
    }
  }

  applyFilter() {
    this.showDossierFilter = true;
  }
}
